import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

const { TaxCertLabel, CountryCode } = Constants;

export const PFTaxViewTaxForm = (props) => {
  const { i18n } = props;
  const taxCertLabel = i18n.getString(TaxCertLabel.TaxCertificate);

  return (
    <GlobalViewTaxForm
      {...props}
      taxCertLabel={taxCertLabel}
      countryCode={CountryCode.PF}
    />
  );
};

PFTaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
